import React, { useState, useEffect } from 'react';

interface CookieConsentProps {
  darkMode: boolean;
}

const CookieConsent: React.FC<CookieConsentProps> = ({ darkMode }) => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    localStorage.setItem('cookie_consent_date', new Date().toISOString());
    setShowBanner(false);
  };

  if (!showBanner) return null;

  const theme = {
    bg: darkMode ? 'bg-[#252526]' : 'bg-white',
    text: darkMode ? 'text-[#d4d4d4]' : 'text-gray-900',
    border: darkMode ? 'border-[#3e3e42]' : 'border-gray-200',
    button: darkMode ? 'bg-[#0e639c] hover:bg-[#1177bb]' : 'bg-blue-600 hover:bg-blue-700',
    link: darkMode ? 'text-[#4a9eff] hover:text-[#6bb5ff]' : 'text-blue-600 hover:text-blue-700',
    closeBtn: darkMode ? 'text-gray-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-700',
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 px-4 py-3 shadow-lg border-t">
      <div className={`max-w-7xl mx-auto ${theme.bg} ${theme.border} border rounded-lg px-4 py-3`}>
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className={`text-xs sm:text-sm ${theme.text} text-center sm:text-left flex-1`}>
            We use cookies, including Google AdSense, to improve your experience. By continuing, you agree to our{' '}
            <a href="/privacy" className={`${theme.link} underline`}>Privacy Policy</a>.
          </p>
          <div className="flex items-center gap-2 flex-shrink-0">
            <button
              onClick={handleAccept}
              className={`px-4 py-1.5 text-white text-xs sm:text-sm font-medium rounded transition-colors ${theme.button}`}
            >
              Accept
            </button>
            <button
              onClick={handleAccept}
              className={`p-1.5 rounded transition-colors ${theme.closeBtn}`}
              aria-label="Close"
              title="Accept and close"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;

